export const Orientation = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
} as const;
export type Orientation = typeof Orientation[keyof typeof Orientation];

export const MachineMapSyncStatus = {
    FAILED: '0',
    SUCCESS: '1',
} as const;
export type MachineMapSyncStatus = (typeof MachineMapSyncStatus)[keyof typeof MachineMapSyncStatus];

export const MachineStatus = {
    REMOVED: '0',
    ACTIVE: '1',
    NOT_SETUP: '2',
} as const;
export type MachineStatus = (typeof MachineStatus)[keyof typeof MachineStatus];

export const MachineConnectionStatus = {
    ON: '1',
    OFF: '0',
} as const;
export type MachineConnectionStatus = (typeof MachineConnectionStatus)[keyof typeof MachineConnectionStatus];

export const DeviceType = {
    SIGNAGE: 'signage',
    KIOSK: 'kiosk',
} as const;
export type DeviceType = (typeof DeviceType)[keyof typeof DeviceType];
